import { Injectable } from '@angular/core';
import { CoralogixLogSeverity, CoralogixRum, UserContextConfig } from '@coralogix/browser';
import { CoralogixConfig, ErrorEventPayload, InfoEventPayload } from '../types';
import { DevelopmentService } from '@libs/shared/utilities/services/development/development.service';
import { ERROR_EVENT_ENUM, INFO_EVENT_ENUM } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class CoralogixService {
  constructor(private developmentService: DevelopmentService) {}

  initialise(config: CoralogixConfig, userContextConfig?: UserContextConfig): void {
    CoralogixRum.init({
      public_key: config.apiKey,
      application: config.appName,
      version: config.appVersion,
      environment: config.environment,
      coralogixDomain: config.domain,
      ignoreErrors: [/.*webpack-dev-server.*/],
      user_context: userContextConfig,
      traceParentInHeader: {
        enabled: true,
        options: {
          propagateTraceHeaderCorsUrls: [new RegExp('https://.*.kody.services'), new RegExp('https://.*.kodypay.com')],
        },
      },
      sessionRecordingConfig: {
        enable: config.environment === 'production',
        autoStartSessionRecording: true,
        sampling: {
          scroll: 150,
          mousemove: false,
        },
      },
      labelProviders: config.labelProviders,
    });
  }

  setUserContext(userContextConfig: UserContextConfig): void {
    if (this.developmentService.isDevMode()) {
      return;
    }
    CoralogixRum.setUserContext(userContextConfig);
  }

  clearUserContext(): void {
    if (this.developmentService.isDevMode()) {
      return;
    }
    CoralogixRum.setUserContext({ user_id: '', user_name: '' });
  }

  error(event: ERROR_EVENT_ENUM, data?: ErrorEventPayload): void {
    if (this.developmentService.isDevMode()) {
      // console.error('>>>> CoralogixService error: ', event, ', data: ', data);
      return;
    }

    CoralogixRum.error(event, data);
  }

  log(event: INFO_EVENT_ENUM, data?: InfoEventPayload): void {
    if (this.developmentService.isDevMode()) {
      // console.log('>>>> CoralogixService log: ', event, ', data: ', data);
      return;
    }

    CoralogixRum.log(CoralogixLogSeverity.Info, event, data);
  }
}
